import * as i0 from '@angular/core';
import { Injectable, Component, ViewChild, Input, NgModule } from '@angular/core';
import { map, takeUntil, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { Subject } from 'rxjs';
import { getStepStatusUpdate } from 'visa-store';
import { environment } from 'environment-configurations';
import * as moment from 'moment';
import 'moment-timezone';
import * as i2 from 'authentication';
import * as i3 from 'base-review-comments-library';
import * as i4 from 'ngx-toastr';
import * as i6 from 'base-generate-forms-library';
import * as i7 from '@angular/platform-browser';
import * as i8 from 'base-review-petition-library';
import * as i9 from 'primeng/api';
import * as i10 from '@angular/common';
import * as i11 from '@angular/forms';
import * as i12 from 'ngx-extended-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import * as i13 from 'primeng/confirmdialog';
import * as i14 from 'primeng/button';
import * as i15 from 'primeng/inputtextarea';
import { PrimengLibraryModule } from 'primeng-library';

class ReviewPetitonNewService {
    constructor(http) {
        this.http = http;
    }
    // getHtmlFile(filename: string) {
    //   return this.http.get(`assets/visa-html-files/${filename}/${filename}.html`, { responseType: 'text' })
    //     .pipe(
    //       map(html => {
    //         return html;
    //       })
    //     );
    // }
    getHtmlFile(pdfUrl, payload) {
        return this.http.post(`${pdfUrl}editPdfDetails`, payload)
            .pipe(map((response) => {
            if ([200, 204].includes(response.status)) {
                return response;
            }
            else {
                return null;
            }
        }));
    }
    saveHtmlFile(pdfUrl, payload) {
        return this.http.post(`${pdfUrl}saveEditPdfDetails`, payload)
            .pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
ReviewPetitonNewService.ɵfac = function ReviewPetitonNewService_Factory(t) { return new (t || ReviewPetitonNewService)(i0.ɵɵinject(i1.HttpClient)); };
ReviewPetitonNewService.ɵprov = i0.ɵɵdefineInjectable({ token: ReviewPetitonNewService, factory: ReviewPetitonNewService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewPetitonNewService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["reviewCommentForm"];
const _c1 = ["content"];
const _c2 = ["iframe"];
function ReviewPetitonNewComponent_div_7_div_1_div_4_small_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1, "(Signed form)");
    i0.ɵɵelementEnd();
} }
function ReviewPetitonNewComponent_div_7_div_1_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const form_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(form_r8.familyName);
} }
function ReviewPetitonNewComponent_div_7_div_1_div_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const form_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("Updated: ", form_r8.updatedOn, "");
} }
function ReviewPetitonNewComponent_div_7_div_1_div_4_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_7_div_1_div_4_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const form_r8 = i0.ɵɵnextContext().$implicit; const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.openTab(form_r8); });
    i0.ɵɵelementEnd();
} }
function ReviewPetitonNewComponent_div_7_div_1_div_4_span_16_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1, "|");
    i0.ɵɵelementStart(2, "a", 45);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_7_div_1_div_4_span_16_Template_a_click_2_listener($event) { i0.ɵɵrestoreView(_r24); const form_r8 = i0.ɵɵnextContext().$implicit; const ctx_r22 = i0.ɵɵnextContext(3); return ctx_r22.handleDeleteComment($event, form_r8); });
    i0.ɵɵtext(3, "Delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c3 = function () { return { standalone: true }; };
function ReviewPetitonNewComponent_div_7_div_1_div_4_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "textarea", 47);
    i0.ɵɵlistener("ngModelChange", function ReviewPetitonNewComponent_div_7_div_1_div_4_div_17_Template_textarea_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r27); const form_r8 = i0.ɵɵnextContext().$implicit; return form_r8.comments = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 48);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_7_div_1_div_4_div_17_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r27); const form_r8 = i0.ɵɵnextContext().$implicit; const ctx_r28 = i0.ɵɵnextContext(3); return ctx_r28.handleSaveNew(form_r8); });
    i0.ɵɵelement(3, "span", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const form_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", form_r8.comments)("autoResize", true)("ngModelOptions", i0.ɵɵpureFunction0(4, _c3));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !(form_r8.comments == null ? null : form_r8.comments.trim()));
} }
function ReviewPetitonNewComponent_div_7_div_1_div_4_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 50);
} }
const _c4 = function (a0) { return { "form-item-changed": a0 }; };
const _c5 = function () { return ["I-129"]; };
function ReviewPetitonNewComponent_div_7_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, ReviewPetitonNewComponent_div_7_div_1_div_4_small_5_Template, 2, 0, "small", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ReviewPetitonNewComponent_div_7_div_1_div_4_div_6_Template, 2, 1, "div", 31);
    i0.ɵɵtemplate(7, ReviewPetitonNewComponent_div_7_div_1_div_4_div_7_Template, 2, 1, "div", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 33);
    i0.ɵɵelementStart(9, "button", 34);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_7_div_1_div_4_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r32); const form_r8 = ctx.$implicit; const ctx_r31 = i0.ɵɵnextContext(3); return ctx_r31.viewHtmlForm(form_r8); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, ReviewPetitonNewComponent_div_7_div_1_div_4_button_10_Template, 1, 0, "button", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 36);
    i0.ɵɵtext(12, "Comment ");
    i0.ɵɵelementStart(13, "div", 17);
    i0.ɵɵelementStart(14, "a", 37);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_7_div_1_div_4_Template_a_click_14_listener($event) { i0.ɵɵrestoreView(_r32); const form_r8 = ctx.$implicit; const ctx_r33 = i0.ɵɵnextContext(3); return ctx_r33.onShowComment($event, form_r8); });
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, ReviewPetitonNewComponent_div_7_div_1_div_4_span_16_Template, 4, 0, "span", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, ReviewPetitonNewComponent_div_7_div_1_div_4_div_17_Template, 4, 5, "div", 39);
    i0.ɵɵtemplate(18, ReviewPetitonNewComponent_div_7_div_1_div_4_div_18_Template, 1, 0, "div", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const form_r8 = ctx.$implicit;
    const formIndex_r9 = ctx.index;
    const item_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c4, form_r8.isEditedFormGenerated === false));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", form_r8.isEditedFormGenerated === false ? form_r8.docName + "*" : form_r8.docName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", form_r8.signed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", form_r8.familyName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", form_r8.updatedOn);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !form_r8.signed && i0.ɵɵpureFunction0(12, _c5).includes(form_r8.docName));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(!!(form_r8.comments == null ? null : form_r8.comments.trim()) ? "View/Edit" : "Add");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!(form_r8.comments == null ? null : form_r8.comments.trim()));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", form_r8.showComment);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formIndex_r9 < item_r4.list.length - 1);
} }
function ReviewPetitonNewComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "All Forms");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ReviewPetitonNewComponent_div_7_div_1_div_4_Template, 19, 13, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", item_r4.list);
} }
function ReviewPetitonNewComponent_div_7_div_2_div_5_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 50);
} }
function ReviewPetitonNewComponent_div_7_div_2_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 42);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 33);
    i0.ɵɵelementStart(8, "button", 34);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_7_div_2_div_5_div_1_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r42); const form_r38 = ctx.$implicit; const ctx_r41 = i0.ɵɵnextContext(4); return ctx_r41.viewHtmlForm(form_r38); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ReviewPetitonNewComponent_div_7_div_2_div_5_div_1_div_9_Template, 1, 0, "div", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const form_r38 = ctx.$implicit;
    const formIndex_r39 = ctx.index;
    const item_r4 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(form_r38.docName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Updated: ", form_r38.updatedOn, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", formIndex_r39 < item_r4.list.length - 1);
} }
function ReviewPetitonNewComponent_div_7_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ReviewPetitonNewComponent_div_7_div_2_div_5_div_1_Template, 10, 3, "div", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r4.list);
} }
const _c6 = function (a0) { return { "form-review-accordian-mb": a0 }; };
const _c7 = function (a0, a1) { return { "pi-angle-up": a0, "pi-angle-down": a1 }; };
function ReviewPetitonNewComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "div", 52);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_7_div_2_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r47); const item_r4 = i0.ɵɵnextContext().$implicit; return item_r4.accShow = !item_r4.accShow; });
    i0.ɵɵelement(2, "span", 53);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ReviewPetitonNewComponent_div_7_div_2_div_5_Template, 2, 1, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c6, !item_r4.accShow));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c7, item_r4.accShow, !item_r4.accShow));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r4.accShow);
} }
function ReviewPetitonNewComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ReviewPetitonNewComponent_div_7_div_1_Template, 5, 1, "div", 23);
    i0.ɵɵtemplate(2, ReviewPetitonNewComponent_div_7_div_2_Template, 6, 9, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r4.name === "All Forms");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r4.name !== "All Forms");
} }
const _c8 = function (a0) { return { "form-tab-active": a0 }; };
function ReviewPetitonNewComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_13_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r52); const i_r50 = ctx.index; const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.showTab(i_r50); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 56);
    i0.ɵɵlistener("click", function ReviewPetitonNewComponent_div_13_Template_span_click_3_listener($event) { i0.ɵɵrestoreView(_r52); const i_r50 = ctx.index; const ctx_r53 = i0.ɵɵnextContext(); return ctx_r53.closeTab($event, i_r50); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const editableForm_r49 = ctx.$implicit;
    const i_r50 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c8, ctx_r2.shownTabIndex === i_r50 + 1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(editableForm_r49.name);
} }
function ReviewPetitonNewComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵelement(1, "iframe", 58, 59);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r3.safeUrl, i0.ɵɵsanitizeResourceUrl);
} }
const _c9 = function (a0) { return { "is-wizard-gray-container": a0 }; };
const _c10 = function (a0) { return { "d-none": a0 }; };
class ReviewPetitonNewComponent {
    constructor(store, authenticationService, apiService, toastr, reviewPetitonNewService, apiGenerateForms, sanitizer, apiReviewPetition, confirmationService) {
        var _a, _b, _c;
        this.store = store;
        this.authenticationService = authenticationService;
        this.apiService = apiService;
        this.toastr = toastr;
        this.reviewPetitonNewService = reviewPetitonNewService;
        this.apiGenerateForms = apiGenerateForms;
        this.sanitizer = sanitizer;
        this.apiReviewPetition = apiReviewPetition;
        this.confirmationService = confirmationService;
        this.observableSubscription$ = new Subject();
        this.newListDocuments = [];
        this.shownTabIndex = 0;
        this.formArray = [];
        this.draftPDFPath = '';
        this.boundReceiveMessage = this.receiveMessage.bind(this);
        window.removeEventListener('message', this.boundReceiveMessage, false);
        window.addEventListener('message', this.boundReceiveMessage, false);
        this.listDocuments = [];
        this.isUserHasReviewerPermission = (_c = (_b = (_a = this.authenticationService.currentUserValue) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.includes('PETITION_REVIEWER')) !== null && _c !== void 0 ? _c : false;
    }
    ngOnChanges(changes) {
        if (changes.primaryData.currentValue) {
            this.updateFormControlState();
            // if (this.primaryData.jsonInput?.applicantsList) {
            //   // this.updateFormControlState();
            // } else {
            //   //["TRANS", "CAP", "EXTNSN"].includes(this.primaryData.petitionType) && 
            //   if (!(this.primaryData.visaName === "H1B - SPECIALTY OCCUPATION" && this.primaryData.visatype === "H1-B" && this.primaryData.superTaskTypeCode === "NONIMMPET" && this.primaryData.caseType === "PETITION")) {
            //     this.apiGenerateForms.getDependentFormInfo(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId)
            //       .pipe(take(1))
            //       .subscribe((response: ImagilityBaseResponse) => {
            //         this.dependentFormInfo = response.data;
            //         this.updateFormControlState();
            //       });
            //   } else {
            //     this.updateFormControlState();
            //   }
            // }
        }
    }
    ngOnInit() {
        this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            var _a;
            if (((_a = response === null || response === void 0 ? void 0 : response[0]) === null || _a === void 0 ? void 0 : _a.status) === 200) {
                this.getReviewComments();
            }
        });
        this.getGenernatedPetition(true);
        // Listen for messages from the iframe
        // window.addEventListener('message', this.receiveMessage.bind(this), false);
    }
    // receiveMessage(event: MessageEvent) {
    //   if (event.data && event.data.type === 'iframeHeight') {
    //     this.adjustIframeHeight(event.data.height);
    //   }
    // }
    // adjustIframeHeight(height: number) {
    //   const iframeElement = this.iframe.nativeElement;
    //   iframeElement.style.height = `${height}px`;
    // }
    getGenernatedPetition(isDraft = true) {
        this.apiReviewPetition.getReviewPetitiondocDraft(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, isDraft)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.postGeneratePetition(response);
            }
        });
    }
    postGeneratePetition(response) {
        this.enableViewDraftButton = response.data.isExist;
        this.draftGeneratedDate = response.data.lastModifiedTime;
        // // Sanitize the URL
        // this.draftPDFPath = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.docs}${response.data.path.substring(23)}`);
        this.draftPDFPath = null;
        if (response.data.path !== null && response.data.path !== undefined && response.data.path.trim() !== '') {
            this.draftPDFPath = `${environment.docs}${response.data.path.substring(23)}?v=${new Date().getTime()}`;
        }
        this.getReviewComments();
    }
    generatePetition(isDraft = true) {
        this.draftPDFPath = null;
        this.apiReviewPetition.postReviewPetitiondocDraft(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, isDraft)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.data) {
                this.toastr.success(response.message);
                this.postGeneratePetition(response);
            }
        });
    }
    // loadExternalHtml() {
    //   this.reviewPetitonNewService.getHtmlFile('I-485')
    //     .pipe(take(1))
    //     .subscribe(html => {
    //       const div: HTMLDivElement = this.content.nativeElement;
    //       div.innerHTML = html;
    //       // Optionally, evaluate script tags
    //       // const scripts = div.getElementsByTagName('script');
    //       // for (let i = 0; i < scripts.length; i++) {
    //       //   const script = scripts[i];
    //       //   const newScript = this.renderer.createElement('script');
    //       //   newScript.type = script.type ? script.type : 'text/javascript';
    //       //   if (script.innerHTML) {
    //       //     newScript.innerHTML = script.innerHTML;
    //       //   } else if (script.src) {
    //       //     newScript.src = script.src;
    //       //   }
    //       //   this.renderer.appendChild(this.el.nativeElement, newScript);
    //       // }
    //     });
    // }
    getReviewComments() {
        this.apiService.getI140ReviewComments(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.data && response.data.length > 0) {
                //Removing isReviewReq filter and adding a check for Other category as part of bugfix - IM-20189
                this.listDocuments = response.data.map((x) => (Object.assign(Object.assign({}, x), { docs: x.docs.filter((y) => y.docName !== 'Other') })));
                const listDocuments = this.listDocuments
                    .map((element) => element.docs.map(doc => {
                    return Object.assign(Object.assign({}, doc), { parentTitleSheetId: element.titleSheetId, updatedOn: doc.updatedOn ? this.convertToLocalTime(doc.updatedOn) : null });
                }))
                    .reduce((acc, val) => acc.concat(val), []);
                const documentTypeSet = new Set(listDocuments.map(doc => doc.documentType));
                this.newListDocuments = [];
                if (documentTypeSet.has('Standard Documents') &&
                    listDocuments.some(doc => doc.documentType === 'Standard Documents' && doc.isGenerated)) {
                    this.newListDocuments.push({
                        name: 'All Forms',
                        list: listDocuments.filter(doc => doc.documentType === 'Standard Documents' && doc.isGenerated)
                    });
                }
                this.newListDocuments.push(...Array.from(documentTypeSet)
                    .filter((type) => type !== 'Standard Documents' &&
                    listDocuments.some(doc => doc.documentType === type && doc.isGenerated))
                    .map((type) => ({
                    name: type,
                    list: listDocuments.filter(doc => doc.documentType === type && doc.isGenerated)
                        .map(doc => {
                        return Object.assign(Object.assign({}, doc), { showComment: false });
                    }),
                    accShow: false
                })));
            }
        });
    }
    convertToLocalTime(gmtTime) {
        const gmtMoment = moment.tz(gmtTime, 'DD MMM YY / hh:mm A', 'GMT');
        const localTime = gmtMoment.clone().tz(moment.tz.guess());
        return localTime.format('DD MMM YY / hh:mm A');
    }
    ngAfterViewInit() {
        this.reviewCommentForm.valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            if (this.reviewCommentForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.updateFormControlState();
        // this.adjustIframeHeight();
    }
    updateFormControlState() {
        if (this.reviewCommentForm) {
            if (!this.isUserHasReviewerPermission || this.disabledControls) {
                this.reviewCommentForm.control.disable();
            }
            else {
                this.reviewCommentForm.control.enable();
            }
            // HTML Loader
            // this.loadExternalHtml();
        }
    }
    handleSaveNew(docReview) {
        // docReview.showComment = false;
        const payload = {
            comments: docReview.comments,
            petitionId: this.primaryData.caseId,
            titleSheetDetailId: docReview.titleSheetDetailId,
            titleSheetId: docReview.parentTitleSheetId,
        };
        this.apiService.postI140ReviewComments(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, payload).pipe(take(1))
            .subscribe((response) => {
            this.toastr.success(response.message);
            this.store.dispatch(new MarkCleanFormAction({
                dirty: false
            }));
        });
    }
    handleDeleteComment(event, docReview) {
        event.preventDefault();
        docReview.comments = null;
        this.handleSaveNew(docReview);
    }
    onShowComment(event, docReview) {
        event.preventDefault();
        docReview.showComment = !docReview.showComment;
    }
    handleSave(currentItem, refItem = null) {
        const payload = {
            "comments": currentItem.comments,
            "petitionId": this.primaryData.caseId,
            "titleSheetDetailId": currentItem.titleSheetDetailId,
            "titleSheetId": refItem ? refItem.titleSheetId : currentItem.titleSheetId,
        };
        this.apiService.postI140ReviewComments(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.toastr.success(response.message);
            this.store.dispatch(new MarkCleanFormAction({
                dirty: false
            }));
        });
    }
    postMessage(tabIndexOrForm, eventType) {
        let properties;
        if (eventType === 'openTab') {
            properties = {
                message: eventType,
                form: tabIndexOrForm
            };
        }
        else {
            properties = {
                message: eventType,
                tabIndex: tabIndexOrForm
            };
        }
        this.iframe.nativeElement.contentWindow.postMessage({
            type: 'editablePdfUpdateSaveUpload',
            properties
        }, '*');
    }
    closeTab(event, tabIndex) {
        event.stopPropagation();
        if (this.shownTabIndex - 1 === tabIndex) {
            this.postMessage(tabIndex, 'closeTab');
        }
        else {
            this.formArray.splice(tabIndex, 1);
            this.shownTabIndex = 0;
        }
    }
    showTab(tabIndex) {
        if (this.shownTabIndex > 0) {
            this.postMessage(tabIndex, 'showTab');
        }
        else {
            this.editHtmlForm(this.formArray[tabIndex].form);
        }
    }
    showFullDraftTab() {
        if (this.shownTabIndex > 0) {
            this.postMessage(0, 'showFullDraftTab');
        }
        else {
            this.shownTabIndex = 0;
        }
    }
    openTab(form) {
        if (this.shownTabIndex > 0) {
            this.postMessage(form, 'openTab');
        }
        else {
            this.editHtmlForm(form);
        }
    }
    editNecessary(form) {
        // let applicantList: any[] = [];
        // if (this.primaryData.jsonInput?.applicantsList && Array.isArray(this.primaryData.jsonInput.applicantsList)) {
        //   applicantList = this.primaryData.jsonInput.applicantsList;
        // } else if (this.dependentFormInfo?.generateFormFor?.length > 0) {
        //   this.dependentFormInfo.generateFormFor.forEach((element) => {
        //     if (element.applicantList && element.applicantList.length > 0) {
        //       element.applicantList.forEach((ele) => {
        //         ele.isGenerated = true;
        //         ele.isUploaded = false;
        //       });
        //     }
        //   });
        //   this.dependentFormInfo.generateFormFor
        //     .filter(element => Array.isArray(element.applicantList) && element.applicantList.length)
        //     .forEach(element => {
        //       let applicantListTemp = Array.from(new Set(element.applicantList));
        //       const applicantListIds = applicantList.map(x => x.id);
        //       applicantListTemp = applicantListTemp.filter((x: any) => {
        //         return !applicantListIds.includes(x.id);
        //       });
        //       applicantList.push(...applicantListTemp);
        //     });
        // } else if (this.dependentFormInfo?.applicantList?.length > 0) {
        //   applicantList.push(...this.dependentFormInfo.applicantList);
        // }
        // if (form && (['G-28'].includes(form.docName) || (form.docName === 'I-129' && this.primaryData.petitionType === "CAP" && this.primaryData.visaName === "H1B - SPECIALTY OCCUPATION" && this.primaryData.visatype === "H1-B" && this.primaryData.superTaskTypeCode === "NONIMMPET" && this.primaryData.caseType === "PETITION"))) {
        //   this.editPayload = {
        //     "applicantList": [],
        //     "generateAll": true
        //   };
        //   const savePayload = {
        //     "applicantList": [],
        //     "generateAll": true,
        //     "elements": ''
        //   };
        //   // localStorage.setItem('editPdfUrlPayload', JSON.stringify(this.editPayload));
        //   localStorage.setItem('savePdfUrlPayload', JSON.stringify(savePayload));
        // } else if (Array.isArray(applicantList)) {
        //   // const payloadApplicantList = applicantList.applicantList[0];
        //   const payloadApplicantList = applicantList.map(applincant => applincant.id);
        //   this.editPayload = {
        //     "applicantList": [...payloadApplicantList],
        //     "generateAll": true
        //   };
        //   const savePayload = {
        //     "applicantList": [...payloadApplicantList],
        //     "generateAll": true,
        //     "elements": ''
        //   };
        //   // localStorage.setItem('editPdfUrlPayload', JSON.stringify(this.editPayload));
        //   localStorage.setItem('savePdfUrlPayload', JSON.stringify(savePayload));
        // }
        this.editPayload = {
            "applicantList": form.familyId ? [form.familyId] : [],
            "generateAll": true
        };
        // localStorage.setItem('editPdfUrlPayload', JSON.stringify(this.editPayload));
        localStorage.setItem('savePdfUrlPayload', JSON.stringify(Object.assign(Object.assign({}, this.editPayload), { "elements": '' })));
    }
    editHtmlForm(form) {
        if (this.primaryData && form.docName) {
            this.safeUrl = null;
            // if (!this.formArray.some(x => x.name === form.docName)) {
            const fileName = form.docName.replace(/-/g, '');
            // this.pdfURL = `${environment.baseUrl}/type/GCFLY/caseType/${this.primaryData.caseType}/caseId/${this.primaryData.caseId}/form/${fileName}/task/${this.primaryData.taskId}/`;
            let type = this.primaryData.getTaskType;
            // if (this.primaryData.getTaskType === 'I485' && this.primaryData.immigrationCategory === 'GCFLY') {
            //   type = this.primaryData.immigrationCategory;
            // }
            this.pdfURL = `/type/${type}/caseType/${this.primaryData.caseType}/caseId/${this.primaryData.caseId}/form/${fileName}/task/${this.primaryData.taskId}/`;
            this.editNecessary(form);
            this.reviewPetitonNewService.getHtmlFile(this.pdfURL, this.editPayload)
                .pipe(take(1))
                .subscribe((responseData) => {
                var _a;
                if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.status) === 200 && ((_a = responseData === null || responseData === void 0 ? void 0 : responseData.data) === null || _a === void 0 ? void 0 : _a.elements)) {
                    let response = responseData.data;
                    this.getHtmlElements = JSON.parse(JSON.stringify(response.elements));
                    localStorage.setItem('reviewPetitionJsonData', JSON.stringify(this.getHtmlElements));
                    // localStorage.setItem('savePdfUrl', `${this.pdfURL}saveEditPdfDetails`);
                    // Sanitize the URL
                    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.htmlFileLocation.replace('G28', 'G-28').replace('form.html', 'review-form.html'));
                    // let url;
                    // if (form.docName === 'I-129') {
                    //   url = `assets/visa-html-files/I-129/review-form.html`;
                    // } else if (form.docName === 'G-28') {
                    //   url = `assets/visa-html-files/G-28/review-form.html`;
                    // } else if (form.docName === 'I-485') {
                    //   url = `assets/visa-html-files/I-485-V2/review-form.html`;
                    // } else if (form.docName === 'I-539') {
                    //   url = `assets/visa-html-files/I-539/review-form.html`;
                    // } else if (form.docName === 'I-360') {
                    //   url = `assets/visa-html-files/I-360/review-form.html`;
                    // } else if (form.docName === 'I-589') {
                    //   url = `assets/visa-html-files/I-589/review-form.html`;
                    // } else if (form.docName === 'I-907') {
                    //   url = `assets/visa-html-files/I-907/review-form.html`;
                    // } else if (form.docName === 'I-539A') {
                    //   url = `assets/visa-html-files/I-539A/review-form.html`;
                    // }
                    // this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                    if (!this.formArray.some(x => x.name === form.docName)) {
                        this.formArray = [...this.formArray, {
                                name: form.docName,
                                form
                            }];
                        this.shownTabIndex = this.formArray.length;
                    }
                    else {
                        this.shownTabIndex = this.formArray.findIndex(x => x.name === form.docName) + 1;
                    }
                    // } else if (responseData?.status === 204 && Array.isArray(this.editPayload?.applicantList) && this.editPayload.applicantList.length > 0) {
                    //   this.secondEditHtmlForm(form)
                }
                else {
                    this.toastr.info('Data not found for the form.');
                }
            });
            // }
        }
    }
    // secondEditHtmlForm(form) {
    //   this.editPayload = {
    //     ...this.editPayload,
    //     applicantList: []
    //   };
    //   this.reviewPetitonNewService.getHtmlFile(this.pdfURL, this.editPayload)
    //     .pipe(take(1))
    //     .subscribe((responseData: any) => {
    //       if (responseData && responseData?.status === 200 && responseData?.data?.elements) {
    //         let response = responseData.data;
    //         this.getHtmlElements = JSON.parse(JSON.stringify(response.elements));
    //         localStorage.setItem('reviewPetitionJsonData', JSON.stringify(this.getHtmlElements));
    //         // localStorage.setItem('savePdfUrl', `${this.pdfURL}saveEditPdfDetails`);
    //         // Sanitize the URL
    //         this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.htmlFileLocation.replace('G28', 'G-28').replace('form.html', 'review-form.html'));
    //         // let url;
    //         // if (form.docName === 'I-129') {
    //         //   url = `assets/visa-html-files/I-129/review-form.html`;
    //         // } else if (form.docName === 'G-28') {
    //         //   url = `assets/visa-html-files/G-28/review-form.html`;
    //         // } else if (form.docName === 'I-485') {
    //         //   url = `assets/visa-html-files/I-485-V2/review-form.html`;
    //         // } else if (form.docName === 'I-539') {
    //         //   url = `assets/visa-html-files/I-539/review-form.html`;
    //         // } else if (form.docName === 'I-360') {
    //         //   url = `assets/visa-html-files/I-360/review-form.html`;
    //         // } else if (form.docName === 'I-589') {
    //         //   url = `assets/visa-html-files/I-589/review-form.html`;
    //         // }
    //         // this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    //         if (!this.formArray.some(x => x.name === form.docName)) {
    //           this.formArray = [...this.formArray, {
    //             name: form.docName,
    //             form
    //           }];
    //           this.shownTabIndex = this.formArray.length;
    //         } else {
    //           this.shownTabIndex = this.formArray.findIndex(x => x.name === form.docName) + 1;
    //         }
    //       } else {
    //         this.toastr.info('Data not found for the form.');
    //       }
    //     });
    // }
    receiveMessage(event) {
        // console.log(event);
        if (event.data.type === 'editablePdfPostSave' && this.shownTabIndex !== 0) {
            this.confirm('Are you sure you want to save your changes?', Object.assign(Object.assign({}, event.data), { properties: {
                    properties: {
                        message: 'onSave'
                    }
                } }));
        }
        else if (event.data.type === 'editablePdfUpdateSaveUploadPayload') {
            if (!this.shallowEqual(JSON.parse(event.data.properties.text).elements, this.getHtmlElements)) {
                if (event.data.properties.properties.message === 'closeTab') {
                    this.confirm('Are you sure you want to close this tab? Any unsaved data will be lost.', event.data);
                }
                else if (['showTab', 'openTab', 'showFullDraftTab'].includes(event.data.properties.properties.message)) {
                    this.confirm('Are you sure you want to switch to another tab? Any unsaved data will be lost.', event.data);
                }
            }
            else {
                this.postConfirmation(event.data);
            }
            // console.log(JSON.parse(event.data.properties.text), this.getHtmlElements, event.data)
            // console.log(event.data);
        }
    }
    shallowEqual(obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }
    postConfirmation(data) {
        if (data.properties.properties.message === 'onSave') {
            this.reviewPetitonNewService.saveHtmlFile(this.pdfURL, Object.assign(Object.assign({}, JSON.parse(data.text)), { applicantList: JSON.parse(JSON.stringify(this.editPayload.applicantList)) }))
                .pipe(take(1))
                .subscribe((response) => {
                if (response) {
                    this.toastr.success(response.message);
                    this.formArray.splice(this.shownTabIndex - 1, 1);
                    this.shownTabIndex = 0;
                    this.getReviewComments();
                }
            });
        }
        else if (data.properties.properties.message === 'closeTab') {
            this.formArray.splice(data.properties.properties.tabIndex, 1);
            this.shownTabIndex = 0;
        }
        else if (data.properties.properties.message === 'showTab') {
            this.editHtmlForm(this.formArray[data.properties.properties.tabIndex].form);
        }
        else if (data.properties.properties.message === 'openTab') {
            this.editHtmlForm(data.properties.properties.form);
        }
        else if (data.properties.properties.message === 'showFullDraftTab') {
            this.shownTabIndex = 0;
        }
    }
    confirm(message, data) {
        this.confirmationService.confirm({
            message,
            header: 'Confirmation',
            // icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.postConfirmation(data);
            },
        });
    }
    // onPagesLoaded() {
    //   const pdfViewerElem = document.querySelector('ngx-extended-pdf-viewer') as HTMLElement;
    //   if (pdfViewerElem) {
    //     // const resizeObserver = new ResizeObserver(() => {
    //     const pageElements = pdfViewerElem.querySelectorAll('.page') as NodeListOf<HTMLElement>;
    //     if (pageElements.length > 0) {
    //       const totalHeight = Array.from(pageElements).reduce((sum, page) => sum + page.offsetHeight, 0);
    //       if (totalHeight === 0) {
    //         setTimeout(() => {
    //           this.onPagesLoaded()
    //         }, 500);
    //         return;
    //       }
    //       // console.log('Total height:', totalHeight);
    //       pdfViewerElem.style.height = `${totalHeight}px`;
    //     }
    //     // });
    //     // resizeObserver.observe(pdfViewerElem);
    //   }
    //   // const pdfViewerElem = document.querySelector('ngx-extended-pdf-viewer') as HTMLElement;
    //   // if (pdfViewerElem) {
    //   //   const pageElements = pdfViewerElem.querySelectorAll('.page') as NodeListOf<HTMLElement>;
    //   //   if (pageElements.length > 0) {
    //   //     const totalHeight = Array.from(pageElements).reduce((sum, page) => sum + page.offsetHeight, 0);
    //   //     pdfViewerElem.style.height = `${totalHeight}px`;
    //   //   }
    //   // }
    // }
    // adjustIframeHeight() {
    //   const iframeElement = this.iframe.nativeElement;
    //   // Ensure iframe content is loaded and accessible
    //   let iframeDocument
    //   try {
    //     iframeDocument = iframeElement.contentDocument || iframeElement.contentWindow.document;
    //   } catch (error) {
    //     console.log(error);
    //   }
    //   if (iframeDocument) {
    //     // Adjust the height based on the content
    //     iframeElement.style.height = iframeDocument.body.scrollHeight + 'px';
    //   }
    // }
    viewHtmlForm(form) {
        window.open(form.fileLocationURL, '_blank');
    }
    ngOnDestroy() {
        window.removeEventListener('message', this.boundReceiveMessage, false);
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
ReviewPetitonNewComponent.ɵfac = function ReviewPetitonNewComponent_Factory(t) { return new (t || ReviewPetitonNewComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2.AuthenticationService), i0.ɵɵdirectiveInject(i3.APIReviewComments), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(ReviewPetitonNewService), i0.ɵɵdirectiveInject(i6.APIGenerateForms), i0.ɵɵdirectiveInject(i7.DomSanitizer), i0.ɵɵdirectiveInject(i8.APIReviewPetition), i0.ɵɵdirectiveInject(i9.ConfirmationService)); };
ReviewPetitonNewComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ReviewPetitonNewComponent, selectors: [["lib-review-petiton-new"]], viewQuery: function ReviewPetitonNewComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 3);
        i0.ɵɵviewQuery(_c2, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reviewCommentForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iframe = _t.first);
    } }, inputs: { disabledControls: "disabledControls", primaryData: "primaryData", isWizard: "isWizard" }, features: [i0.ɵɵNgOnChangesFeature], decls: 30, vars: 22, consts: [[1, "container-fluid"], [1, "row"], [1, "col-3", "gray-container", 3, "ngClass"], ["reviewCommentForm", "ngForm"], [1, "header"], [4, "ngFor", "ngForOf"], [1, "col-9", "pr-0"], [1, "gray-container", 3, "ngClass"], [1, "form-view-tabs-container"], [1, "form-view-tab", 3, "ngClass", "click"], ["class", "form-view-tab", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "form-content"], [1, "form-content-header", 3, "ngClass"], [1, "row", "m-0", "py-3"], [1, "col-6"], [1, "form-generate-title"], [1, "col-6", "text-right"], [1, "float-right"], ["type", "button", 1, "form-generate-button", 3, "click"], [1, "form-generate-status"], [1, "ngx-extended-pdf-viewer", 3, "ngClass"], ["height", "800px", "useBrowserLocale", "true", 1, "letter-pdf", 2, "width", "100%", "display", "block", 3, "src", "scrollMode", "spread"], ["class", "iframe-container", 4, "ngIf"], [4, "ngIf"], ["class", "form-review-accordian-holder", 3, "ngClass", 4, "ngIf"], [1, "all-forms-header"], ["class", "form-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "form-item", 3, "ngClass"], [1, "form-container"], [1, "form-details"], [1, "form-name"], ["class", "form-updated-name", 4, "ngIf"], ["class", "form-updated", 4, "ngIf"], [1, "form-actions"], ["pButton", "", "type", "button", "icon", "pi pi-eye", 1, "p-button-text", "view-btn-form-review", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-pencil", "class", "p-button-text edit-btn-form-review", 3, "click", 4, "ngIf"], [1, "add-comment"], [1, "comment-anchor", 3, "click"], ["class", "ml-1", 4, "ngIf"], ["class", "textarea-container", 4, "ngIf"], ["class", "form-item-border-bottom", 4, "ngIf"], [1, "form-updated-name"], [1, "form-updated"], ["pButton", "", "type", "button", "icon", "pi pi-pencil", 1, "p-button-text", "edit-btn-form-review", 3, "click"], [1, "ml-1"], [1, "ml-1", "comment-anchor", 3, "click"], [1, "textarea-container"], ["pInputTextarea", "", "rows", "1", "placeholder", "Enter", 3, "ngModel", "autoResize", "ngModelOptions", "ngModelChange"], ["type", "button", 1, "submit-btn", 3, "disabled", "click"], [1, "pi", "pi-arrow-up"], [1, "form-item-border-bottom"], [1, "form-review-accordian-holder", 3, "ngClass"], [1, "clearfix", "form-review-accordian", 3, "click"], [1, "pi", 3, "ngClass"], ["class", "form-item", 4, "ngFor", "ngForOf"], [1, "form-item"], [1, "fa", "fa-times-circle", 3, "click"], [1, "iframe-container"], ["title", "form", "frameborder", "0", "width", "100%", "scrolling", "yes", "noborder", "0", "seamless", "", 3, "src"], ["iframe", ""]], template: function ReviewPetitonNewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "form", null, 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtext(6, "All forms linked with this petition");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, ReviewPetitonNewComponent_div_7_Template, 3, 2, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵlistener("click", function ReviewPetitonNewComponent_Template_div_click_11_listener() { return ctx.showFullDraftTab(); });
        i0.ɵɵtext(12, " Full Petition (Draft)");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, ReviewPetitonNewComponent_div_13_Template, 4, 4, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelementStart(15, "div", 12);
        i0.ɵɵelementStart(16, "div", 13);
        i0.ɵɵelementStart(17, "div", 14);
        i0.ɵɵelementStart(18, "span", 15);
        i0.ɵɵtext(19, " Generate Petition for review ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 16);
        i0.ɵɵelementStart(21, "div", 17);
        i0.ɵɵelementStart(22, "button", 18);
        i0.ɵɵlistener("click", function ReviewPetitonNewComponent_Template_button_click_22_listener() { return ctx.generatePetition(true); });
        i0.ɵɵtext(23, " Generate Draft Petition ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "span", 19);
        i0.ɵɵtext(25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 20);
        i0.ɵɵelement(27, "ngx-extended-pdf-viewer", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(28, ReviewPetitonNewComponent_div_28_Template, 3, 1, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(29, "p-confirmDialog");
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c9, ctx.isWizard));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.newListDocuments);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c9, ctx.isWizard));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c8, ctx.shownTabIndex === 0));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.formArray);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c10, !(ctx.shownTabIndex === 0 && ctx.draftPDFPath)));
        i0.ɵɵadvance(10);
        i0.ɵɵtextInterpolate1(" ", ctx.enableViewDraftButton && ctx.draftPDFPath ? "Print generated on " + ctx.draftGeneratedDate : "No Draft Generated", " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c10, !(ctx.shownTabIndex === 0 && ctx.draftPDFPath)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("src", ctx.draftPDFPath)("scrollMode", "vertical")("spread", "off");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.pdfURL && ctx.safeUrl && ctx.shownTabIndex > 0);
    } }, directives: [i10.NgClass, i11.ɵangular_packages_forms_forms_ba, i11.NgControlStatusGroup, i11.NgForm, i10.NgForOf, i12.NgxExtendedPdfViewerComponent, i10.NgIf, i13.ConfirmDialog, i14.ButtonDirective, i11.DefaultValueAccessor, i15.InputTextarea, i11.NgControlStatus, i11.NgModel], styles: [".row[_ngcontent-%COMP%]{margin-left:-15px;margin-right:-15px}.subheader[_ngcontent-%COMP%]{font-size:15px;font-weight:600;margin-top:15px}.sub-subheader[_ngcontent-%COMP%]{font-size:14px;font-weight:600}.comment-section[_ngcontent-%COMP%], .sub-subheader[_ngcontent-%COMP%]{margin-top:10px}.comment-section[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{width:100%;height:100px}.save-button[_ngcontent-%COMP%]{margin-top:10px}.btn-success_disabled[_ngcontent-%COMP%]{background-color:#d4d4d4;border-color:#d4d4d4;color:#fff}.iframe-container[_ngcontent-%COMP%]{margin-top:3px;position:relative;width:100%;height:calc(100vh - 260px);overflow:hidden;background-color:#f9f9f9}.iframe-container[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:calc(100% - 10px);height:100%;border:0;margin:5px}.gray-container[_ngcontent-%COMP%]{padding:0 5px;background-color:#f6f6f6;border-radius:4px;box-shadow:1px 1px 3px 0 rgba(0,0,0,.1),-1px 1px 3px 0 rgba(0,0,0,.1);overflow-x:auto;height:calc(100vh - 210px)}.gray-container.is-wizard-gray-container[_ngcontent-%COMP%]{height:830px}.gray-container[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{font-size:16px;font-weight:700;margin-top:10px;color:#000}.gray-container[_ngcontent-%COMP%]   .all-forms-header[_ngcontent-%COMP%]{background-color:#01a0da;color:#fff;padding:5px 10px;margin-top:10px;font-size:14px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]{padding:5px 5px 0;background-color:#fff;margin-bottom:0}.gray-container[_ngcontent-%COMP%]   .form-item.form-item-changed[_ngcontent-%COMP%]{background-color:#fffee4}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]:last-child{margin-bottom:10px;padding-bottom:7px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .form-container[_ngcontent-%COMP%]{display:flex}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .form-container[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]{flex-grow:1}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .form-container[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .form-name[_ngcontent-%COMP%]{font-weight:700;font-size:14px;color:#000;line-height:17px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .form-container[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .form-updated-name[_ngcontent-%COMP%]{text-transform:capitalize;font-size:13px;color:#000;line-height:13px;margin-bottom:2px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .form-container[_ngcontent-%COMP%]   .form-details[_ngcontent-%COMP%]   .form-updated[_ngcontent-%COMP%]{font-size:11px;color:#999;line-height:14px;margin-bottom:2px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .form-container[_ngcontent-%COMP%]   .form-actions[_ngcontent-%COMP%]{flex-shrink:0}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .add-comment[_ngcontent-%COMP%]{font-size:14px;color:#959595;line-height:20px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .add-comment[_ngcontent-%COMP%]   .comment-anchor[_ngcontent-%COMP%]{font-size:14px;color:#3498db;cursor:pointer;text-decoration:none;line-height:20px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .textarea-container[_ngcontent-%COMP%]{display:flex;align-items:normal;border:1px solid #d9d9d9;border-radius:5px;padding:1px 4px;box-shadow:0 2px 4px rgba(0,0,0,.1);width:100%;margin-top:5px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .textarea-container[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{border:none!important;outline:none;resize:none;width:100%;font-size:14px!important;padding:5px;line-height:1.5;overflow:hidden!important;box-shadow:none!important}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .textarea-container[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::-moz-placeholder{color:#b0b0b0}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .textarea-container[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder{color:#b0b0b0}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .textarea-container[_ngcontent-%COMP%]   .submit-btn[_ngcontent-%COMP%]{background:#fff;outline:none;cursor:pointer;color:#007ad9;border-radius:50%;border:1px solid #007ad9;width:24px;height:24px;text-align:center;padding:0;margin-top:3px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .textarea-container[_ngcontent-%COMP%]   .submit-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{width:22px;line-height:22px;font-size:14px}.gray-container[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .form-item-border-bottom[_ngcontent-%COMP%]{height:1px;background-color:#01a0da;box-shadow:0 0 0 1px #e6e6e6;margin-left:-5px;margin-right:-5px;margin-top:7px}.gray-container[_ngcontent-%COMP%]   .form-review-accordian-holder.form-review-accordian-mb[_ngcontent-%COMP%]{margin-bottom:9px}.gray-container[_ngcontent-%COMP%]   .form-review-accordian-holder[_ngcontent-%COMP%]   .form-review-accordian[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 1px 3px 0 rgba(0,0,0,.1);font-size:14px;padding:5px;margin-bottom:1px;cursor:pointer}.gray-container[_ngcontent-%COMP%]   .form-review-accordian-holder[_ngcontent-%COMP%]   .form-review-accordian[_ngcontent-%COMP%] > .pi[_ngcontent-%COMP%]{font-size:14px;margin-top:1px;margin-right:5px}.gray-container[_ngcontent-%COMP%]   .form-review-accordian-holder[_ngcontent-%COMP%]   .form-review-accordian[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{float:left;line-height:21px}.gray-container[_ngcontent-%COMP%]   .form-review-accordian-holder[_ngcontent-%COMP%]   .form-item[_ngcontent-%COMP%]   .form-item-border-bottom[_ngcontent-%COMP%]{background-color:#e6e6e6;box-shadow:none}.gray-container[_ngcontent-%COMP%]   .form-view-tabs-container[_ngcontent-%COMP%]{width:calc(100% + 10px);margin:0 -5px;border-radius:4px 4px 0 0;height:40px;background-color:#f6f6f6;box-shadow:0 1px 3px 0 rgba(0,0,0,.3)}.gray-container[_ngcontent-%COMP%]   .form-view-tabs-container[_ngcontent-%COMP%]   .form-view-tab[_ngcontent-%COMP%]{border-bottom:5px solid #f6f6f6;background-color:#f6f6f6;box-shadow:1px 0 3px 0 rgba(0,0,0,.3),-1px 0 3px 0 rgba(0,0,0,.3);float:left;margin-left:1px;line-height:21px;padding:10px 15px 4px;color:#4a4a4a;font-size:14px;cursor:pointer}.gray-container[_ngcontent-%COMP%]   .form-view-tabs-container[_ngcontent-%COMP%]   .form-view-tab.form-tab-active[_ngcontent-%COMP%]{color:#01a0da;border-bottom:5px solid #01a0da}.gray-container[_ngcontent-%COMP%]   .form-view-tabs-container[_ngcontent-%COMP%]   .form-view-tab[_ngcontent-%COMP%]   .fa.fa-times-circle[_ngcontent-%COMP%]{color:#3d3d63;margin-left:15px;cursor:pointer;font-size:14px}.gray-container[_ngcontent-%COMP%]   .form-content[_ngcontent-%COMP%]   .form-content-header[_ngcontent-%COMP%]   .form-generate-title[_ngcontent-%COMP%]{color:#626262;font-weight:700;font-size:16px}.gray-container[_ngcontent-%COMP%]   .form-content[_ngcontent-%COMP%]   .form-content-header[_ngcontent-%COMP%]   .form-generate-button[_ngcontent-%COMP%]{border:1px solid #01a0da;border-radius:4px;color:#01a0da;font-weight:600;font-size:14px;background-color:#fff;padding:5px 10px;cursor:pointer;width:160px}.gray-container[_ngcontent-%COMP%]   .form-content[_ngcontent-%COMP%]   .form-content-header[_ngcontent-%COMP%]   .form-generate-status[_ngcontent-%COMP%]{display:block;color:#a3a6b4;font-size:13px;text-align:center;font-weight:400;margin-top:2px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewPetitonNewComponent, [{
        type: Component,
        args: [{
                selector: 'lib-review-petiton-new',
                templateUrl: 'review-petiton-new.component.html',
                styleUrls: ['review-petiton-new.component.scss']
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.AuthenticationService }, { type: i3.APIReviewComments }, { type: i4.ToastrService }, { type: ReviewPetitonNewService }, { type: i6.APIGenerateForms }, { type: i7.DomSanitizer }, { type: i8.APIReviewPetition }, { type: i9.ConfirmationService }]; }, { reviewCommentForm: [{
            type: ViewChild,
            args: ['reviewCommentForm']
        }], disabledControls: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: ['content', { static: true }]
        }], iframe: [{
            type: ViewChild,
            args: ['iframe', { static: false }]
        }], isWizard: [{
            type: Input
        }] }); })();

class ReviewPetitonNewModule {
}
ReviewPetitonNewModule.ɵfac = function ReviewPetitonNewModule_Factory(t) { return new (t || ReviewPetitonNewModule)(); };
ReviewPetitonNewModule.ɵmod = i0.ɵɵdefineNgModule({ type: ReviewPetitonNewModule });
ReviewPetitonNewModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            NgxExtendedPdfViewerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ReviewPetitonNewModule, { declarations: [ReviewPetitonNewComponent], imports: [PrimengLibraryModule,
        NgxExtendedPdfViewerModule], exports: [ReviewPetitonNewComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewPetitonNewModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ReviewPetitonNewComponent
                ],
                imports: [
                    PrimengLibraryModule,
                    NgxExtendedPdfViewerModule
                ],
                exports: [
                    ReviewPetitonNewComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of review-petiton-new
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ReviewPetitonNewComponent, ReviewPetitonNewModule, ReviewPetitonNewService };
//# sourceMappingURL=review-petiton-new.js.map
